import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Modal from 'gatsby-theme-core/src/components/modal';
import Content from 'gatsby-theme-core/src/components/content';
import Form from './form/form-component';

const Popup = ({
  text,
  openAfterSeconds,
  strapiFormForm,
  form,
  thanxPage,
  thanxMessageTitle,
  thanxMessageSubTitle,
  thanxMessageFooterText,
  className,
}) => {
  const [open, setOpen] = useState(false);
  const seconds = parseFloat((openAfterSeconds || 0) * 1000);

  useEffect(() => {
    if (Number.isNaN(seconds)) {
      return undefined;
    }
    const timer = setTimeout(() => {
      setOpen(true);
    }, seconds);
    return () => clearTimeout(timer);
  }, [seconds]);

  return (
    <div className={className}>
      <Modal
        styles={{
          root: {
            zIndex: '9999',
          },
        }}
        open={open}
        onCloseModal={() => setOpen(false)}
      >
        <InnerModal>
          <StyledContent $content={text} />
          {(form || strapiFormForm) && (
            <FormWrapper>
              <Form
                strapiFormForm={strapiFormForm}
                form={form}
                thanxPage={thanxPage}
                thanxMessageTitle={thanxMessageTitle}
                thanxMessageSubTitle={thanxMessageSubTitle}
                thanxMessageFooterText={thanxMessageFooterText}
              />
            </FormWrapper>
          )}
        </InnerModal>
      </Modal>
    </div>
  );
};

const StyledContent = styled(Content)`
  img {
    max-width: 14rem;
  }
`;

const InnerModal = styled.div`
  padding: 1rem;
`;

const FormWrapper = styled.div`
  margin-top: 2rem;
`;

export default styled(Popup)`
  .react-responsive-modal-root {
    display: none;
  }
`;
